/**
 * Algolia Widget Builder functions
 *
 **/

custom.algoliaWidgetBuilder = (function () {
  // Create the render function
  const createDataAttribtues = (refinement) =>
    Object.keys(refinement)
      .map((key) => {
        if (
          (key === 'value' || key === 'label') &&
          refinement[key] &&
          typeof refinement[key] === 'string'
        ) {
          return `data-${key}="${refinement[key].replace(/"/g, '&quot;')}"`;
        }
        return `data-${key}="${refinement[key]}"`;
      })
      .join(' ');

  const renderListItem = (item) => `
    ${item.refinements
      .map((refinement) => {
        let refinementLabel = refinement.label
          ? custom.utils.titleCaseWithExceptions(refinement.label)
          : '';

        if (refinement.attribute === 'named_tags.Discontinued') {
          refinementLabel = 'Discontinued';
        }
        if (refinement.attribute === 'named_tags.Timestamp') {
          refinementLabel = 'New Arrivals';
        }
        if (refinement.attribute === 'inventory_quantity') {
          refinementLabel = 'In Stock';
        }

        return `<div class="ais-current-refined-values--item spacer-1--mr spacer-1--mt">
            <button class="ais-current-refined-values--link plp-pill plp-pill--selected " ${createDataAttribtues(
              refinement,
            )}><div>${refinementLabel}<span class="sr-only">(${
          refinement.count
        })</span><span class="ais-current-refined-values--close plp-pill__close"></span></div></button>
          </div>`;
      })
      .join('')}
`;

  const renderCurrentRefinements = (renderOptions) => {
    const { items, refine, widgetParams } = renderOptions;
    const widgetContainer = document.querySelector(widgetParams.container);
    const itemHtml = items
      .map((item) => {
        return renderListItem(item);
      })
      .join('');
    widgetContainer.innerHTML = itemHtml;

    const toggleButtons = widgetContainer.querySelectorAll(
      '.ais-current-refined-values--link',
    );

    [...toggleButtons].forEach((element) => {
      element.addEventListener('click', (event) => {
        const item = Object.keys(event.currentTarget.dataset).reduce(
          (acc, key) => ({
            ...acc,
            [key]: event.currentTarget.dataset[key],
          }),
          {},
        );

        refine(item);
      });
    });
  };

  const newArrivalsToggle = (renderOptions, isFirstRender) => {
    const { items, refine, widgetParams } = renderOptions;

    if (isFirstRender) {
      const root = document.createElement('div');
      root.className = `ais-root ais-RefinementList`;
      const body = document.createElement('div');
      body.className = 'ais-body ais-RefinementList--body';
      const list = document.createElement('div');
      body.style = 'max-height: none;';
      list.className = `ais-RefinementList--list ais-refinement-list--list full-width-container`;

      body.appendChild(list);
      root.appendChild(body);
      widgetParams.container.appendChild(root);
    }
    widgetParams.container.querySelector(
      '.ais-RefinementList--list',
    ).innerHTML = items
      .map((item) => custom.algoliaUtils.itemTemplate(item))
      .join('');

    [...widgetParams.container.querySelectorAll('label')].forEach((element) => {
      element.addEventListener(
        'click',
        custom.utils.debounce((event) => {
          const isRefined = event.target.checked;
          isRefined == true ? refine(event.target.value) : refine('%7B%7D');
        }, 10),
      );
    });
  };
  const inStockToggle = (renderOptions, isFirstRender) => {
    const { items, refine, widgetParams } = renderOptions;

    if (isFirstRender) {
      const root = document.createElement('div');
      root.className = `ais-root ais-RefinementList`;
      const body = document.createElement('div');
      body.className = 'ais-body ais-RefinementList--body';
      const list = document.createElement('div');
      body.style = 'max-height: none;';
      list.className = `ais-RefinementList--list ais-refinement-list--list full-width-container`;

      body.appendChild(list);
      root.appendChild(body);
      widgetParams.container.appendChild(root);
    }
    widgetParams.container.querySelector(
      '.ais-RefinementList--list',
    ).innerHTML = items
      .map((item) => custom.algoliaUtils.itemTemplate(item))
      .join('');

    [...widgetParams.container.querySelectorAll('label')].forEach((element) => {
      element.addEventListener(
        'click',
        custom.utils.debounce((event) => {
          const isRefined = event.target.checked;
          isRefined == true ? refine(event.target.value) : refine('%7B%7D');
        }, 10),
      );
    });
  };

  const renderPriceMenu = (renderOptions, isFirstRender) => {
    // Use `hasNoResults` in earlier minor versions.
    const { items, refine, widgetParams } = renderOptions;

    if (isFirstRender) {
      const root = document.createElement('div');
      root.className = `ais-root ais-RefinementList refinement-list`;
      const header = document.createElement('div');
      header.className = 'ais-RefinementList--header ais-header';
      header.innerHTML = `<span class="tippy-container">Price <span class="tippy-icon inline-block relative js-tippy" title="$ = < $499 <br>$$ = $500-$999 <br>$$$ = $1000-$1999 <br>$$$$ = > $2000 <br>*Based on MSRP of approximate 5’ x 8’ size."><span class="inline-block border border-primary rounded-full w-4 h-4 text-center">?</span></span></span>`;
      const body = document.createElement('div');
      body.className =
        'ais-body ais-RefinementList--body refinement-list__container';
      const list = document.createElement('div');
      list.className = `ais-RefinementList--list ais-refinement-list--list refinement-list__items`;

      body.appendChild(list);

      root.appendChild(header);
      root.appendChild(body);
      widgetParams.container.appendChild(root);
    }

    widgetParams.container.querySelector(
      '.ais-RefinementList--list',
    ).innerHTML = items
      .map((item) => custom.algoliaUtils.itemTemplate(item))
      .join('');

    [...widgetParams.container.querySelectorAll('label')].forEach((element) => {
      element.addEventListener(
        'click',
        custom.utils.debounce((event) => {
          refine(event.target.value);
        }, 10),
      );
    });
  };

  /**
   * buildWidget
   * @params {myInstantSearch} object - InstantSearch instance
   * @params {instantsearch} Object - Algolia instantsearch object
   * @params {widgetType} str - type of widget to build
   * @params {widgetOptions} Object - Options for the widget
   */
  function buildWidget(
    myInstantSearch,
    instantsearch,
    widgetType,
    widgetOptions,
  ) {
    if (widgetType === 'currentRefinedValues') {
      const customCurrentRefinements =
        instantsearch.connectors.connectCurrentRefinements(
          renderCurrentRefinements,
        );
      const filteredAttributes = widgetOptions.attributes.map(function (item) {
        return item['name'];
      });
      // Instantiate the custom widget
      myInstantSearch.addWidgets([
        customCurrentRefinements({
          container: widgetOptions.container,
          includedAttributes: filteredAttributes,
        }),
      ]);
      return;
    }
    if (widgetType === 'clearRefinements') {
      const cssClasses = widgetOptions.mobile
        ? 'btn w-full btn--secondary'
        : 'utility-xsmall content-subtle underline';
      myInstantSearch.addWidgets([
        instantsearch.widgets.clearRefinements({
          container: widgetOptions.container,
          includedAttributes: widgetOptions.attributes,
          templates: {
            resetLabel({ hasRefinements }, { html }) {
              if (widgetOptions.mobile) {
                return html`<span class="${cssClasses}">Clear all</span>`;
              }
              return html`<span class="${cssClasses}"
                ><strong>${hasRefinements ? 'Clear all' : ''}</strong></span
              >`;
            },
          },
          cssClasses: {
            button: widgetOptions.mobile ? 'w-full' : '',
            root: widgetOptions.mobile
              ? 'w-full ais-ClearRefinements'
              : 'ais-ClearRefinements spacer-1--mt',
          },
        }),
      ]);
      return;
    }
    if (widgetType === 'stats') {
      myInstantSearch.addWidgets([instantsearch.widgets.stats(widgetOptions)]);
      return;
    }

    if (widgetType === 'sortBySelector') {
      myInstantSearch.addWidgets([instantsearch.widgets.sortBy(widgetOptions)]);
      const makeSortBySelector = instantsearch.connectors.connectSortBy(() => {
        custom.dropdownToRadio.init();
      });
      myInstantSearch.addWidgets([makeSortBySelector(widgetOptions)]);
      return;
    }

    if (widgetType === 'refinementListBasic') {
      myInstantSearch.addWidgets([
        instantsearch.widgets.refinementList(widgetOptions),
      ]);
      return;
    }

    //refinementList builder
    if (widgetType === 'refinementList' || widgetType === 'refinementListSize') {
      const renderRefinementList = (renderOptions, isFirstRender) => {
        const isColorWidget = widgetOptions.attribute === 'named_tags.Color';
        const isProductTypeWidget = widgetOptions.attribute === 'product_type';
        const { items, refine, widgetParams } = renderOptions;

        if (isFirstRender) {
          if (!widgetOptions.cssClasses) {
            widgetOptions.cssClasses = {};
          }
          const headerClasses = `ais-RefinementList--header ais-header  ${
            widgetOptions.cssClasses.header
              ? widgetOptions.cssClasses.header
              : ''
          }`;
          const rootClasses = `ais-root ais-RefinementList refinement-list ${
            widgetOptions.cssClasses.root ? widgetOptions.cssClasses.root : ''
          }`;
          const bodyClasses = `ais-body ais-RefinementList--body refinement-list__container ${
            widgetOptions.cssClasses.body ? widgetOptions.cssClasses.body : ''
          }`;
          const listClasses = `ais-RefinementList--list ais-refinement-list--list refinement-list__items ${
            widgetOptions.cssClasses.list ? widgetOptions.cssClasses.list : ''
          }`;
          const root = document.createElement('div');
          root.className = rootClasses;
          const header = document.createElement('div');
          header.className = headerClasses;
          const body = document.createElement('div');
          body.className = bodyClasses;
          const list = document.createElement('div');
          list.className = listClasses;

          body.appendChild(list);

          root.appendChild(header);
          root.appendChild(body);
          widgetParams.container.appendChild(root);
        }

        const refinedCount = items.filter((item) => item.isRefined).length;
        let refinementFacets = items
          .map((item) =>
            isColorWidget
              ? custom.algoliaUtils.colorTemplate(item)
              : isProductTypeWidget
              ? custom.algoliaUtils.productTypeTemplate(item)
              : custom.algoliaUtils.itemTemplate(item),
          )
          .join('');
        if(widgetType === 'refinementListSize') {
          refinementFacets = custom.algoliaUtils.rugsSizeTemplate(items);
        }
        if (isProductTypeWidget && refinedCount <= 0) {
          const allSelectedLabel = `<div class="product-type-item product-type-item--active">
            <span class="refined product-type-holder mt-2">
              <span class="product-type-label w-full align-baseline capitalize refined title-medium content-default">All</span>
            </span>
          </div>`;
          refinementFacets = allSelectedLabel + refinementFacets;
        }

        widgetParams.container.querySelector(
          '.ais-RefinementList--list',
        ).innerHTML = refinementFacets;

        const headerTitle = custom.algoliaUtils.getHeaderLabel(
          widgetOptions.attribute,
          refinedCount,
        );

        const hasRefinementOptions = items.length > 0;
        if (hasRefinementOptions) {
          widgetParams.container.classList.remove('hidden');
        } else {
          widgetParams.container.classList.add('hidden');
        }

        widgetParams.container.querySelector(
          '.ais-RefinementList--header',
        ).innerHTML = headerTitle;

        [...widgetParams.container.querySelectorAll('label')].forEach(
          (element) => {
            element.addEventListener(
              'click',
              custom.utils.debounce((event) => {
                event.preventDefault();
                refine(event.target.value);
              }, 10),
            );
          },
        );
      };

      const customRefinementList =
        instantsearch.connectors.connectRefinementList(renderRefinementList);
      myInstantSearch.addWidgets([
        customRefinementList({
          container: document.querySelector(widgetOptions.container),
          attribute: widgetOptions.attribute,
          limit: 100,
          sortBy: widgetOptions.sortBy ? widgetOptions.sortBy : ['name:asc'],
        }),
      ]);
      return;
    }
    if (widgetType === 'numericMenu') {
      // Create the custom widget
      const customNumericMenu =
        instantsearch.connectors.connectNumericMenu(renderPriceMenu);

      // Instantiate the custom widget
      myInstantSearch.addWidgets([
        customNumericMenu({
          container: document.querySelector(widgetOptions.container),
          attribute: widgetOptions.attribute,
          items: widgetOptions.items,
        }),
      ]);
      return;
    }
    if (widgetType === 'discontinuedToggle') {
      // Create the custom widget
      myInstantSearch.addWidgets([
        instantsearch.widgets.toggleRefinement({
          container: document.querySelector(widgetOptions.container),
          attribute: widgetOptions.attribute,
          templates: {
            labelText(data, { html }) {
              const count =
                data.onFacetValue && data.onFacetValue.count
                  ? data.onFacetValue.count
                  : null;
              // If the item is not refined and the count is 0, do not show the toggle at all.
              const shouldShow =
                data.isRefined || (count && parseInt(count) > 0);
              if (!shouldShow) {
                $(widgetOptions.container).addClass('hidden');
                return html``;
              }
              $(widgetOptions.container).removeClass('hidden');
              //Count someties returns null ?? so we need to check for that
              return html`<div>
                  Discontinued<span
                    class="ais-RefinementList--count utility-xsmall text-grey-4"
                    >${count ? '(' + count + ')' : ''}</span
                  >
                </div>
                <span class="ais-RefinementList--checkmark"></span>`;
            },
          },
          cssClasses: {
            root: 'ais-RefinementList--item js-gtm',
            label: 'ais-RefinementList--label inline-block',
            checkbox: 'ais-RefinementList--checkbox',
          },
        }),
      ]);
      return;
    }

    if (widgetType === 'newArrivalsMenu') {
      // Create the custom widget
      const customNewArrivalsMenu =
        instantsearch.connectors.connectNumericMenu(newArrivalsToggle);

      // Instantiate the custom widget
      myInstantSearch.addWidgets([
        customNewArrivalsMenu({
          container: document.querySelector(widgetOptions.container),
          attribute: widgetOptions.attribute,
          items: widgetOptions.items,
        }),
      ]);
      return;
    }
    if (widgetType === 'inStockMenu') {
      // Create the custom widget
      const customInStockMenu =
        instantsearch.connectors.connectNumericMenu(inStockToggle);

      // Instantiate the custom widget
      myInstantSearch.addWidgets([
        customInStockMenu({
          container: document.querySelector(widgetOptions.container),
          attribute: widgetOptions.attribute,
          items: widgetOptions.items,
        }),
      ]);
      return;
    }
    if (widgetType === 'searchBox') {
      myInstantSearch.addWidgets([
        instantsearch.widgets.searchBox({
          container: document.querySelector(widgetOptions.container),
          placeholder: widgetOptions.placeholder,
          queryHook: widgetOptions.queryHook,
          showSubmit: true,
          showReset: true,
        }),
      ]);
      return;
    }
    if (typeof instantsearch.widgets[widgetType] !== 'undefined') {
      myInstantSearch.addWidgets([
        instantsearch.widgets[widgetType](widgetOptions),
      ]);
      return;
    }
    console.log('widget type undefined', widgetType);
  }

  return {
    buildWidget,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/algolia-widget-builder.js